/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_Step_Submit_DescInputs */

const en_admin_indexnow_step_submit_desc = /** @type {(inputs: Admin_Indexnow_Step_Submit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit every page in sitemap.xml, or paste specific URLs (one per line). Resubmit only when pages change.`)
};

/**
* | output |
* | --- |
* | "Submit every page in sitemap.xml, or paste specific URLs (one per line). Resubmit only when pages change." |
*
* @param {Admin_Indexnow_Step_Submit_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_step_submit_desc = /** @type {((inputs?: Admin_Indexnow_Step_Submit_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Step_Submit_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_step_submit_desc(inputs)
});
export { admin_indexnow_step_submit_desc as "admin.indexnow.step_submit_desc" }